import * as dd from 'dingtalk-jsapi'

const loginDingUitl = (resolve, error) => {
  if (dd.env.platform === 'notInDingTalk') {
    error && error()
  } else {
    dd.ready(() => {
      // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
      dd.runtime.permission.requestAuthCode({
        corpId: 'ding6d7d3ce122708abe',
        onSuccess: result => {
          let code = result.code
          resolve && resolve(code)
        },
        onFail: err => {
          console.log('xxxsssssss', err)
        },
      })
    })
  }
}

export default loginDingUitl



// WEBPACK FOOTER //
// ./src/utils/loginUtils.js